import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button", "chips", "checkbox"]
  static values = { placeholder: String }

  connect() {
    this.open = false
    this._outsideClickHandler = this._handleOutsideClick.bind(this)
    document.addEventListener("click", this._outsideClickHandler)
    this.updateChips()
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClickHandler)
  }

  toggle(event) {
    event.preventDefault()
    this.open = !this.open
    this._syncMenuVisibility()
  }

  toggleOption() {
    this.updateChips()
  }

  remove(event) {
    event.preventDefault()
    const value = event.currentTarget.dataset.value
    const checkbox = this.checkboxTargets.find((cb) => cb.value === value)
    if (checkbox) {
      checkbox.checked = false
      checkbox.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  updateChips() {
    this.chipsTarget.innerHTML = ""
    const selected = this.checkboxTargets.filter((cb) => cb.checked)

    selected.forEach((checkbox) => {
      const chip = document.createElement("span")
      chip.dataset.value = checkbox.value
      chip.className = "inline-flex items-center gap-2 rounded-full bg-[#084572]/10 px-3 py-1 text-sm text-[#084572]"

      const label = document.createElement("span")
      label.textContent = checkbox.dataset.label || checkbox.value
      chip.appendChild(label)

      const removeBtn = document.createElement("button")
      removeBtn.type = "button"
      removeBtn.dataset.action = "checkbox-dropdown#remove"
      removeBtn.dataset.value = checkbox.value
      removeBtn.className = "text-[#084572] hover:text-red-600"
      removeBtn.setAttribute("aria-label", `Remove ${label.textContent}`)
      removeBtn.textContent = "×"
      chip.appendChild(removeBtn)

      this.chipsTarget.appendChild(chip)
    })

    if (this.hasButtonTarget) {
      const label = this.buttonTarget.querySelector(".checkbox-dropdown__label") || this.buttonTarget
      label.textContent = selected.length > 0 ? `${selected.length} selected` : (this.placeholderValue || "Select options…")
    }

    const gapClass = "mt-3"
    if (selected.length > 0) {
      this.chipsTarget.classList.add(gapClass)
    } else {
      this.chipsTarget.classList.remove(gapClass)
    }
  }

  _handleOutsideClick(event) {
    if (!this.open) return
    if (this.element.contains(event.target)) return

    this.open = false
    this._syncMenuVisibility()
  }

  _syncMenuVisibility() {
    if (!this.hasMenuTarget) return
    this.menuTarget.classList.toggle("hidden", !this.open)
  }
}
